import "@total-typescript/ts-reset";

const landingPageSelector = "#rt-collective-landing-page";

if (document.querySelector(landingPageSelector)) {
	import("./front/index.js").then((e) => e.default());
}
